export const DATA_DOG_TRACE_VERSION = '1.4.4'
